import React from 'react';
import { Typography, Box } from '@mui/material';
import { Grid } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';

const PalavraDoPresidente = () => {
    const { isMobile } = useDevice();
    return (
        <Grid style={{ minHeight: '64vh', bgcolor: '#f5f5f5', justifyContent: 'center', display: 'flex' }}>
            <Box sx={{ padding: '2rem', borderRadius: '8px', width: isMobile ? '100%' : '70%' }}>
                <Typography variant="h4" component="h1" gutterBottom style={{ fontSize: isMobile ? '26px' : '' }}>
                    Palavra do Presidente
                </Typography>
                <Typography style={{ fontSize: isMobile ? '14px' : '' }}>
                    <Typography variant="body1" paragraph>
                        Prefeitos e prefeitas,
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Evitar que pautas-bombas avancem no Congresso Nacional e prejudiquem
                        ainda mais os cofres municipais é o principal objetivo da grande mobilização convocada pela Confederação Nacional de Municípios (CNM) para o mês de fevereiro. Prefeitos, vice-prefeitos, vereadores
                        e demais gestores municipais são esperados no dia 24 de fevereiro, na sede da CNM, em Brasília. Com a retomada das
                        atividades da Câmara dos Deputados e do Senado Federal prevista para início de fevereiro, a entidade espera sensibilizar
                        os parlamentares para que não aprovem pautas que devem intensificar a situação calamitosa dos Municípios.   
                    </Typography>
                    <Typography variant="body1" paragraph>
                        “A CNM tem atuado para alertar parlamentares, governo federal, imprensa e sociedade sobre as consequências da
                        aprovação de medidas sem análise técnica e responsabilidade com a saúde fiscal do país. É urgente que o Congresso atue
                        com visão federativa, diálogo e respeito ao equilíbrio fiscal. Os Municípios não podem continuar arcando sozinhos com
                        políticas definidas sem planejamento e sem financiamento”, alerta o presidente da CNM, Paulo Ziulkoski.
                    </Typography>

                </Typography>
            </Box>
        </Grid>
    );
};

export default PalavraDoPresidente;
